const capitalizeFirstLetter = value => value.charAt(0).toUpperCase() + value.slice(1);
const padValue = ({
  value,
  padString,
  targetLength
}) => {
  if (!value && value !== 0) return null;
  return value.toString().padStart(targetLength, padString);
};

export { capitalizeFirstLetter, padValue };
